/**
 * Removes the ta_child identifier from an email address
 * @param {string} email - The email address that may contain a ta_child identifier (e.g. "adam.karbiener+test1+ta_childvULS6e@utrsports.com")
 * @returns {string} The cleaned email address (e.g. "adam.karbiener+test1@utrsports.com")
 */
export function removeUtSuffixIdentifier(email) {
    if (!email) {
        throw new Error('Invalid email format');
    }

    const atIndex = email.indexOf('@');
    if (atIndex === -1) {
        throw new Error('Invalid email format');
    }

    const localPart = email.substring(0, atIndex);
    const domainPart = email.substring(atIndex);
    const characterLength = 6;

    const tennisAustraliaChildSuffixPattern = '+ta_child';
    const tennisAustraliaChildSuffixIndex = localPart.indexOf(tennisAustraliaChildSuffixPattern);

    if (tennisAustraliaChildSuffixIndex !== -1 && localPart.length >= tennisAustraliaChildSuffixIndex + tennisAustraliaChildSuffixPattern.length + characterLength) {
        return localPart.substring(0, tennisAustraliaChildSuffixIndex) + domainPart;
    }

    return email;
}
